import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { Settings as SettingsIcon, Logout as LogoutIcon } from '@mui/icons-material';

const ProfileMenu = ({ anchorEl, onClose, onLogout }) => {
  return (
    <Menu
      id="profile-menu"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      <MenuItem onClick={onClose} sx={{ fontSize: '0.8rem' }}>
        <SettingsIcon sx={{ mr: 1, fontSize: 18 }} />
        Settings
      </MenuItem>
      <MenuItem onClick={onLogout} sx={{ fontSize: '0.8rem' }}>
        <LogoutIcon sx={{ mr: 1, fontSize: 18 }} />
        Logout
      </MenuItem>
    </Menu>
  );
};

export default ProfileMenu;

